import { ActionButton } from '@library/components/buttons';
import type { FormattedNewWagerAttributes } from '@library/types/newWagers';
import { formattedNewWagerDetails } from '@bo-utils/newWagers';
import { useCallback } from 'react';

export interface MemberEntryModalFooterProps {
  canRefundEntry: boolean;
  isRefundBtnDisabled: boolean;
  newWager: FormattedNewWagerAttributes;
  onRefundNewWager: (newWagerId: string) => Promise<void>;
}

export const MemberEntryModalFooter = ({
  canRefundEntry,
  isRefundBtnDisabled,
  newWager,
  onRefundNewWager
}: MemberEntryModalFooterProps) => {
  const { newWagerCreatedDate, selfRefundDate } =
    formattedNewWagerDetails(newWager);
  const { result } = newWager;

  const showRefundButton =
    canRefundEntry && !selfRefundDate && result !== 'refunded';

  const handleRefundNewWager = useCallback(async () => {
    if (newWager) {
      await onRefundNewWager(newWager.id);
    }
  }, [newWager, onRefundNewWager]);

  return (
    <div
      className="border-soFresh-140 flex justify-between border-t px-6 py-4"
      data-testid="member-entry-modal-footer"
    >
      <div className="flex h-9 items-center">
        <p className="text-soClean-180 text-sm">{newWagerCreatedDate}</p>
      </div>
      {showRefundButton && (
        <ActionButton
          disabled={isRefundBtnDisabled}
          handleOnClick={handleRefundNewWager}
          title="Refund"
          variant="primary"
        >
          Refund
        </ActionButton>
      )}
    </div>
  );
};
